import React from 'react';
import * as Household from './household.js';

import * as View from './view.js';
import * as $ from 'jquery';

export class Login extends React.Component {
    render() {
        return (
            <div>
                <h1>Login</h1>
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                    <input class="mdl-textfield__input" type="username" id="auth_username" />
                    <label class="mdl-textfield__label" for="auth_username">Username...</label>
                </div><br />
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                    <input class="mdl-textfield__input" type="password" id="auth_password" />
                    <label class="mdl-textfield__label" for="auth_password">Password...</label>
                </div><br /><br />
                <button class="mdl-button mdl-js-button mdl-button--raised" onClick={() => login()}>Button</button>
            </div>
        );
    }
}

function login() {
    var form = {
        username: $("#auth_username").val(),
        password: $("#auth_password").val()
    }

    var i = 0
    $.ajax("https://api.antipy.com:1550/invoice/auth/check", {
        method: "post",
        data: form,
        dataType: "json",
        success: function (dataIn) {
            var data = dataIn
    
            if (data.success) {
                Household.showSnack("Login Success")
                localStorage.setItem("auth", JSON.stringify(form))
                View.State("customerList")
            }   
        },
        error: function (dataIn) {
            var data = dataIn.responseJSON
        
            if (!data.success) {
                Household.showSnack(data.message)
                View.State("login")
            }  
        },
    })
}

export function checkIfLoggedIn() {
    if (localStorage.getItem("auth")) {
        var loginData = JSON.parse(localStorage.getItem("auth"))
        if (loginData.username && loginData.password) {
            $.ajax("https://api.antipy.com:1550/invoice/auth/check", {
                method: "post",
                data: loginData,
                dataType: "json",
                success: function (dataIn) {
                    var data = dataIn
            
                    if (data.success) {
                        View.State("customerList")
                    }
                },
                error: function (dataIn) {
                    var data = dataIn.responseJSON
                
                    if (!data.success) {
                        View.State("login")
                    }  
            }
    })
        } else {
            View.State("login")
        }
    } else {
        View.State("login")
    }
}


// WEBPACK FOOTER //
// ./src/auth.js